<template>
  <div class="page_ blue_">
    <div class="bg_">
      <div class="tit_">
        <div>
          <p>{{ data.provider_name }}</p>
          <template v-if="lang == 'CHINAESE'">
            <span class="icon_1" v-if="data.is_highcost == 'Y'"></span>
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_24h.jpg"
              alt=""
              v-if="data.is_fullhours === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_jizhen.jpg"
              alt=""
              v-if="data.is_emergency === 'Y'"
            />
          </template>
          <template v-if="lang == 'ENGLISH'">
            <img
              class="myicon"
              src="../assets/medilinkPC/pricelevel_en.jpg"
              alt=""
              v-if="data.is_highcost === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_24h.jpg"
              alt=""
              v-if="data.is_fullhours === 'Y'"
            />
            <img
              class="myicon"
              src="../assets/medilinkPC/icon_jizhen_en.jpg"
              alt=""
              v-if="data.is_emergency === 'Y'"
            />
          </template>
        </div>
        <div>
          <a-button type="primary" @click="toSubscribe(data)">{{
            $t("sublist.yuyueBtn")
          }}</a-button>
        </div>
      </div>

      <div class="con_">
        <div class="block_">
          <div class="tit_s">
            {{ $t("hdetail.des") }}
          </div>
          <div class="con_s">
            <div class="tit_1">
              {{ $t("hdetail.baseInfo") }}
            </div>
            <div class="con_1">
              <div class="flex_1">
                <p>
                  {{ $t("hdetail.hospitalProperty") }}：{{ data.provider_type }}
                </p>
                <p>{{ $t("hdetail.address") }}：{{ data.address }}</p>
              </div>
              <div class="flex_2">
                <p>
                  {{ $t("hdetail.hospitalClass") }}：{{ data.provider_catg }}
                </p>
                <p>
                  {{ $t("hdetail.phone") }}：<span class="blue_"
                    >{{ data.telephone_No1 }}{{ data.telephone_No2 }}</span
                  >
                </p>
              </div>
              <div class="flex_2">
                <p>
                  {{ $t("hdetail.level") }}：<span class="circle_"></span
                  >{{ data.provider_level }}
                </p>
                <p>{{ $t("hdetail.lanuage") }}：{{ data.lang }}</p>
              </div>
            </div>
            <div class="line_"></div>
            <div class="tit_1">
              {{ $t("hdetail.des1") }}
            </div>
            <div class="con_1" v-html="data.introduce"></div>
            <div class="line_"></div>
            <div class="tit_1">
              {{ $t("hdetail.openTime") }}
            </div>
            <div class="con_1 gray_" style="display:block;">
              <div v-for="item in data.hours">
                <p>
                  <span>{{ item.hours_type }}</span
                  >&nbsp;&nbsp;<span>{{ item.remarks }}</span
                  >&nbsp;&nbsp;<span
                    >{{ item.from_day
                    }}<span style="margin-left: 2px;margin-right: 2px;">{{
                      $t("hdetail.to")
                    }}</span
                    >{{ item.to_day }}</span
                  ><span>{{ item.from_time }}-{{ item.to_time }}</span>
                </p>
              </div>
            </div>
            <div class="line_"></div>
            <div class="tit_1">
              {{ $t("hdetail.docPrompt") }}
            </div>
            <div class="con_1 gray_">
              {{ data.provider_remarks }}
            </div>
            <div class="line_"></div>
            <!-- 停车信息因无英文版未作翻译 -->
            <div class="tit_1">
              停车信息
            </div>
            <div class="park" v-if="data.parkingInfo">
              <h5>
                {{
                  data.parkingInfo.parkingReserved == "否"
                    ? "不可预留车位"
                    : "可预留车位"
                }}
              </h5>
              <ul>
                <li>
                  <span>停车收费：</span>
                  <span>{{ data.parkingInfo.feeInfo }}</span>
                </li>
                <li>
                  <span>停车位置：</span>
                  <span>{{ data.parkingInfo.locationAddr }}</span>
                </li>
                <li>
                  <span>温馨提示：</span>
                  <span>{{ data.parkingInfo.prompt }}</span>
                </li>
              </ul>
            </div>
            <span class="con_1 gray_" v-else>暂无相关信息</span>
          </div>
        </div>
        <div class="block_">
          <div class="tit_s">
            {{ $t("hdetail.service") }}
          </div>
          <div class="con_s">
            <div
              class="item_"
              v-for="(item, index) in serviceList"
              :class="{ on: item.show == true }"
            >
              <div class="tit_2" @click="changeShow(index)">
                <span>{{ item.tit }}</span>
                <!-- <span class="btn_" @click="changeShow(index)">{{item.show==true?$t('hdetail.fold'):$t('hdetail.unfold')}}<span class="down_"></span></span> -->
              </div>
              <div class="det_" v-if="item.listid == 2">
                <div class="flex_" v-for="item1 in data.service">
                  <span style="font-weight:bold"
                    >{{ item1.department_name }}:</span
                  >
                  <span>{{ item1.department_introduce }}</span>
                </div>
              </div>
              <div class="det_ flex_det" v-else-if="item.listid == 5">
                <div class="flex_e" v-for="evitem in evList">
                  <div class="topleft">
                    <img
                      :src="evitem.headImg"
                      alt=""
                      v-if="evitem.headImg != null"
                    />
                    <img
                      src="../assets/medilinkPC/userdefault.png"
                      alt=""
                      v-else
                    />
                    <div class="right_">
                      <span>{{
                        evitem.name != null
                          ? evitem.name
                          : $t("hdetail.unknowname")
                      }}</span>
                      <span>{{ evitem.desc }}</span>
                    </div>
                  </div>
                  <div class="topright">
                    <p>
                      <span
                        v-for="(data, index) in 5"
                        :class="isRating(index, evitem.star)"
                      ></span>
                    </p>
                    <span>{{ evitem.createDate }}</span>
                  </div>
                </div>
              </div>
              <div class="det_" v-html="item.des" v-else></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <span @click="back()">{{ $t("hdetail.back") }}</span>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";

export default {
  data() {
    return {
      lang: "",
      data: {},
      title: "可预留车位",
      serviceList: [
        {
          listid: 1,
          tit: this.$t("hdetail.question1"),
          show: true
        },
        {
          listid: 2,
          tit: this.$t("hdetail.question2"),
          show: false
        },
        {
          listid: 3,
          tit: this.$t("hdetail.question3"),
          show: false
        },
        {
          listid: 4,
          tit: this.$t("hdetail.question4"),
          show: false
        }
        // {
        //   listid: 5,
        //   tit: this.$t('hdetail.question5'),
        //   show:false,
        // }
      ],
      evList: [],
      providerCode: this.$route.query.provider_code
    };
  },
  mounted() {
    this.language = this.$i18n.locale;
    this.lang = this.$i18n.locale == "en-us" ? "ENGLISH" : "CHINAESE";
    let hospitalForm = localStorage.getItem("hospitalForm");
    if (hospitalForm) {
      hospitalForm = JSON.parse(hospitalForm);
    } else {
      hospitalForm = {};
    }
    this.fetchDetail(hospitalForm.memctlno);
  },
  filters: {
    filterData: val => {
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        return val;
      }
    }
  },
  methods: {
    fetchDetail() {
      api
        .getProviderDeatil({
          language: this.lang,
          provider_code: this.providerCode.replace(/\s+/g, "")
        })
        .then(res => {
          if (res.data.code === 200) {
            this.data = res.data.data;
            this.serviceList[0].des = res.data.data.location_desc;
            if (res.data.data.service.length > 0) {
              if (this.language == "en-us") {
                this.serviceList[1].name =
                  res.data.data.service[0].department_name_EN;
              } else {
                this.serviceList[1].name =
                  res.data.data.service[0].department_name;
              }
              this.serviceList[1].des =
                res.data.data.service[0].department_introduce;
            }
            this.serviceList[2].des = res.data.data.inpatient_remarks;
            this.serviceList[3].des = res.data.data.cashless_remarks;
            if (this.language == "en-us") {
              this.data.address = this.data.address_EN;
              this.data.provider_catg = this.data.provider_catg_EN;
              this.data.provider_level = this.data.provider_level_EN;
              this.data.provider_name = this.data.provider_name_EN;
              this.data.provider_type = this.data.provider_type_EN;
            }
          }
        });
    },
    changeShow(index) {
      this.serviceList[index].show = !this.serviceList[index].show;
      if (index == 4 && this.serviceList[index].show == true) {
        api
          .getEvaluateInfoList({
            providerCode: this.providerCode.replace(/\s*/g, "")
          })
          .then(res => {
            if (res.data.code === 200) {
              this.evList = res.data.data;
            }
          });
      }
    },
    isRating(index, star) {
      return index + 1 <= star ? "active" : "";
    },
    back() {
      this.$router.push({ name: "HospitalList", query: { isEcho: true } });
    },
    toSubscribe(data) {
      console.log(data);
      this.$router.push({
        name: "Subscribe",
        query: this.$merge(this.$route.query, {
          provider_code: this.$route.query.provider_code,
          provider_name: data.provider_name,
          type: "hos",
          provider_type: data.provider_type
        })
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  width: 100%;
  .park {
    font-size: 14px;
    line-height: 22px;
    h5 {
      font-size: 14px;
    }
    ul {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .bg_ {
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 10px;
    > .tit_ {
      padding: 15px 30px;
      border: 1px solid #f3f3f3;
      font-size: 16px;
      color: #394155;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        margin-bottom: 0;
      }
      img.myicon {
        width: 32px;
        margin-left: 8px;
        margin-top: -3px;
      }
      .icon_1 {
        width: 30px;
        height: 16px;
        display: inline-block;
        background: url(../assets/medilinkPC/pricelevel.png) center center
          no-repeat;
        background-size: 100% 100%;
        margin-left: 10px;
      }
    }
    > .con_ {
      padding: 20px 30px 0px;
      .block_ {
        border-radius: 10px;
        border: 1px solid #e7e7e7;
        padding-bottom: 15px;
        margin-bottom: 20px;
        .tit_s {
          padding: 14px 20px;
          background: #fafafa;
          font-size: 14px;
          border-bottom: 1px solid #e7e7e7;
          border-radius: 10px 10px 0px 0px;
          font-weight: bold;
        }
        .con_s {
          padding: 0 20px;
          font-size: 14px;
          p {
            margin-bottom: 0;
          }
          .tit_1 {
            font-weight: bold;
            padding: 15px 0;
          }
          .line_ {
            height: 1px;
            background-color: #e7e7e7;
            margin-top: 15px;
          }
          .con_1 {
            line-height: 22px;
            display: flex;
            font-weight: normal;
            .flex_1 {
              width: 40%;
            }
            .flex_2 {
              width: 20%;
            }
          }
          .item_ {
            padding: 0 10px;
            .tit_2 {
              position: relative;
              font-weight: bold;
              padding: 10px 0;
              &:before {
                content: "";
                display: block;
                height: 0;
                width: 0;
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto 0;
                left: -10px;
                border: 5px solid;
                border-color: transparent transparent transparent #2c5acc;
              }
              .btn_ {
                color: #2c5acc;
                display: inline-flex;
                align-items: center;
                margin-left: 10px;
                cursor: pointer;
                .down_ {
                  width: 5px;
                  height: 6px;
                  background: url(../assets/medilinkPC/fold.png) center
                    center no-repeat;
                  background-size: 100% 100%;
                  display: inline-block;
                  margin-left: 5px;
                }
              }
            }
            &.on .tit_2::before {
              border-color: #2c5acc transparent transparent transparent;
              top: 5px;
              left: -13px;
            }
            .det_ {
              display: none;
              border-bottom: 1px solid #e7e7e7;
              padding: 0px 0 13px;
              font-weight: normal;
              .flex_e {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0;
                border-bottom: 1px solid #f0f0f0;
                .topleft {
                  display: flex;
                  align-items: flex-start;
                  width: 80%;
                  img {
                    width: 46px;
                    height: 46px;
                    min-width: 46px;
                    border-radius: 46px;
                    margin-right: 10px;
                  }
                  .right_ {
                    font-size: 14px;
                    color: #394155;
                    font-weight: bold;
                    display: flex;
                    flex-direction: column;
                    span {
                      &:last-child {
                        color: #666666;
                        font-size: 12px;
                        font-weight: normal;
                      }
                    }
                  }
                }
                .topright {
                  text-align: right;
                  font-size: 12px;
                  color: #666666;
                  p {
                    display: flex;
                    align-items: center;
                    & > span {
                      width: 18px;
                      height: 18px;
                      background: url(../assets/medilinkPC/star.png) center
                        center no-repeat;
                      background-size: contain;
                      margin-right: 2.5px;
                      &.active {
                        background: url(../assets/medilinkPC/staron.png)
                          center center no-repeat;
                        background-size: contain;
                      }
                    }
                  }
                  & > span {
                    font-size: 9px;
                    color: #999;
                  }
                }
              }
            }
            &:last-child .det_ {
              border-bottom: none;
            }
            &.on {
              .down_ {
                width: 6px;
                height: 5px;
                background: url(../assets/medilinkPC/unfold.png) center
                  center no-repeat;
                background-size: 100% 100%;
              }
              .det_ {
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
.flex_det {
  padding: 0 30px 13px !important;
  border-bottom: none !important;
}
.blue_ {
  color: #2c5acc;
  font-weight: bold;
}
.gray_ {
  color: #666666 !important;
}
.btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  span {
    display: block;
    border: 1px solid #2c5acc;
    color: #2c5acc;
    width: 110px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    margin-right: 30px;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>
